import { inputReexListener } from './shipping-reex';
import { init as initStateButtonsHandler } from '../state-button-handler';
import { bindPannel } from './shipping-utils';
import { i18n } from '@/commons/utils';
import { WOOSMAP_KEY as woosmapKey } from '@/modules-es5/commons/lib/lib-stores';

let autocomplete = null;
let inputSearch = null;
let containerRP = null;
let containerMap = null;
let map = null;
let mapOptions = null;
let countryCode = null;
let isAutocompleteRunning = false;
let markers = [];
let infowindow = null;
let relayPoints = [];
let config = null;
let googleKey = null;
const lastCoords= {};
const AJAX_searchRelayPointByGeoLocation  = 'rest/model/com/decathlon/cube/commerce/order/relaypoint/RelayPointSearchFormActor/searchRelayPointByGeoLocation';

// init
function relayPointGeneric() {
  inputSearch = cube.$id('search-input');
  containerRP = cube.$('.checkout__shipping__relay-point-generic');
  containerMap = cube.$id('rp-map');
  mapOptions = {
    zoom: 15,
    disableDefaultUI: true,
    mapTypeId: window.google.maps.MapTypeId.ROADMAP
  };
  countryCode =  [window.tc_vars.env_country.toLowerCase()];
  if(countryCode[0] === 'es') {
    countryCode = ['es','ad'];
  }
  googleKey = cube.$id('rp-map').dataset.googleKey;

  config = {
    woosmap: {projectKey : woosmapKey, componentRestrictions: {country: countryCode}},
    google: {apiKey : googleKey, componentRestrictions: {country: countryCode}}
  };

  import('./woosmap/autocompletewoosmap.js').then((m) => {
    autocomplete = new window.AutocompleteWoosmapSearchBox(inputSearch, config);
  });
  import('./woosmap/autocompletewoosmap.css');

  inputSearch.addEventListener('autocomplete-woosmap-selectcomplete', (evt) => {
    searchCoordonates(evt.woosmapLocality);
  });

  inputSearch.addEventListener('autocomplete-google-selectcomplete', (evt) => {
    searchCoordonates(evt.placeDetails);
  });

  // After deliveryChanged, display marker on map and scroll to input checked.
  cube.event.on('checkout:relay-point-selected', selectRelayPoint);

  $('.checkout__shipping__stores-list').on('click', '.mobile-btn-map', openRelayPointModal);

  $('body').on('click', '#modal-relay-close', closeRelayPointModal);


  // Carrier filters
  $('#js-dkt-relaypoint_filter').on('change', '.checkout__shipping__filter input', setFilter);

  infowindow = new window.google.maps.InfoWindow();
}

// Triggered when user select a location in the SearchBox
function searchCoordonates(evt) {
  if (isAutocompleteRunning) return;

  if(evt && evt.geometry && evt.geometry.location) {
    lastCoords.latitude = evt.geometry.location.lat();
    lastCoords.longitude = evt.geometry.location.lng();
  }

  else if(evt && evt.location && evt.location.lat) {
    lastCoords.latitude = evt.location.lat;
    lastCoords.longitude = evt.location.lng;
  }

  searchNearestRelayPoints({
    latitude: lastCoords.latitude,
    longitude: lastCoords.longitude,
    filter: JSON.stringify({ shippingOptionIds: checkFilter() }),
    context: cube.$id('relay-point').dataset.context
  });

  handleInitMap();
}

let handleInitMap = () => {
  if (map === null) {
    map = new window.google.maps.Map(containerMap, mapOptions);
    map.addListener('dragend', () => {
      searchNearestRelayPoints({
        latitude: map.getCenter().lat(),
        longitude: map.getCenter().lng(),
        filter: JSON.stringify({ shippingOptionIds: checkFilter() }),
        context: cube.$id('relay-point').dataset.context
      });
    });
  }
};

// From a location {lat, lng, zip}
// Returns the 10 nearest relay points
let searchNearestRelayPoints = (location) => {
  const loader = cube.$id('js-relaypoint-loader');
  loader.classList.add('dkt-relaypoint__loader--is-visible');

  cube.ui.displayLoader(cube.$('.checkout__shipping__result-layout'));
  cube.ajax
    .post(AJAX_searchRelayPointByGeoLocation, location)
    .onSuccess((response) => {
      searchNearestRelayPointsSuccess(response);
      inputReexListener();
      loader.classList.remove('dkt-relaypoint__loader--is-visible');
    })
    .onError((err) => {
      cube.alert.error(i18n('address failed'));
      loader.classList.remove('dkt-relaypoint__loader--is-visible');
    })
    .call();
};

function checkFilter(){
  const allCarrier = cube.$$('.checkout__shipping__filters .checkout__shipping__input');
  const allCarrierName = [];

  allCarrier.forEach((element) => {
    if (element.checked) {
      const item = element.dataset.carrier;
      allCarrierName.push(item);
    }
  });
  return allCarrierName;
};

// Handle response from AJAX_searchRelayPointByGeoLocation
let searchNearestRelayPointsSuccess = (response) => {
  const TO = response.responseTO || {};
  isAutocompleteRunning = false;
  if (TO.data && TO.data.shippingOptions && TO.data.filter) {
    displayPossibleCarrier(TO.data.filter);
    displayRelayPoints(TO.data.shippingOptions);
  } else {
    console.warn('error retreiving location from cube api');
  }
  initStateButtonsHandler();
};

function displayPossibleCarrier(listOfPossibleCarrier){
  if (cube.$id('js-dkt-relaypoint_filter').$$('.checkout__shipping__filter').length < 1) {
    const possibleCarrierArray = listOfPossibleCarrier.shippingOptions;

    /* eslint-disable arrow-body-style*/
    const tpl = possibleCarrierArray.reduce((acc, elem)=>{
      return `${acc}
      <li class="checkout__shipping__checkbox checkout__shipping__filter ${ elem.shippingOptionId }">
        <input type="checkbox" id="carrier-${  elem.shippingOptionId  }" class="checkout__shipping__input" data-carrier="${ elem.shippingOptionId }" />
        <label class="" for="carrier-${  elem.shippingOptionId  }">
          <span>
            <img 
              width="31" 
              height="31"  
              src="/vassets/images/checkout/carriers/${elem.shippingOptionId}.png" 
              onerror="this.onerror=null;this.src='/vassets/images/checkout/carriers/default-pickup-relay.jpg'"
              alt="${elem.shippingOptionDisplayName}" 
              class="logo-filter" 
            />
            ${elem.shippingOptionDisplayName}
          </span>
        </label>
      </li>
      `;
    },'');

    cube.$id('js-dkt-relaypoint_filter').innerHTML = tpl;

    //Need it here to have the correct size of .js-dkt-relaypoint_filter
    displayMapContainer();
  }
};

// Open box relay point, only once
let isMapContainerDisplayed = false;
const displayMapContainer = () => {
  if (isMapContainerDisplayed === false) {
    cube.$('.checkout__shipping__result-layout').classList.add('checkout__shipping__result-layout--open');
    cube.$id('js-dkt-relaypoint_filter').classList.add('checkout__shipping__filters--open');
    window.google.maps.event.trigger(map, 'resize');
  }
  isMapContainerDisplayed = true;

  //Scroll to the container to the top of the viewport
  const pts = containerRP.getBoundingClientRect().top;
  $('body').animate({ scrollTop: pts - 20 }, 200);
};

// Display shipping options in left-col
// If desktop, display markers on maps
let displayRelayPoints = (listShippingOptions) => {
  removePreviousRelayPoints();

  containerRP.$('.checkout__shipping__stores-list').innerHTML = '';

  listShippingOptions.forEach(addRelayPointInLeftCol);
  if (!cube.ui.isMobile()) {
    listShippingOptions.forEach(addRelayPointMarker);
    const bounds = new window.google.maps.LatLngBounds();

    markers.forEach((marker, index) => {
      marker.addListener('click', (event) => {
        const inputToCheck = cube.$(`.checkout__shipping__relay-point-generic .checkout__shipping__input[data-index="${  index  }"]`);

        // Use "event" because when you click on the input, it's undefined
        if(event) {
          $(`.checkout__shipping__relay-point-generic .checkout__shipping__input[data-index="${  index  }"]`).prop('checked', true).change();
        }
        infowindow.setContent(marker.title);
        infowindow.open(map, marker);
        $('.checkout__shipping__stores-list').animate({ scrollTop: inputToCheck.nextElementSibling.offsetTop }, 180);

        initStateButtonsHandler();
      });
      bounds.extend(marker.position);
    });
    map.fitBounds(bounds);
  }

  window.google.maps.event.trigger(map, 'resize');
  relayPoints = listShippingOptions;
  cube.ui.hideLoader(cube.$('.checkout__shipping__result-layout'));
  cube.event.send('checkout:relay-points-loaded');
  delegateMarkers();
};

// Remove markers from map
// Clear relay points in left-col
let removePreviousRelayPoints = () => {
  markers.forEach((marker) => {
    marker.setMap(null);
  });
  markers = [];
};

//Template for the list of relaypoint
let addRelayPointInLeftCol = (shippingInfo, index) => {
  const rp = shippingInfo.relayPoint || {};
  const date = shippingInfo.promiseDate;
  const formatDate = window.moment(date).format(i18n('delivery.RelayPoint.date.format'));
  const address1 = rp.address.address1 === null || rp.address.address1 === '' ? '' : `${rp.address.address1  }<br/>`;
  const address3 = rp.address.address3 === null || rp.address.address3 === '' ? '' : `${rp.address.address3} `;
  const zipCode = rp.address.zipCode === null || rp.address.zipCode === '' ? '' : `${rp.address.zipCode}, `;
  const tooltipInfo = `<div class="shipping-tooltip shipping-tooltip__relay">
    <div class="shipping-tooltip__arrow">
        <div class="icon icon-i-line"></div>
    </div>
    <div class="shipping-tooltip__holder">
        <div class="shipping-tooltip__content">
            <h3 class="shipping-tooltip__title">
            ${i18n('pdm.shipping.information')}
            </h3>
            <p class="shipping-tooltip__text">${shippingInfo.description}</p>
          </div>
      </div>
    </div>`;
  let deliveryLabel =`<u>${shippingInfo.deliveryLabel} ${formatDate}</u>`;
  const deliveryLabelPhraseApp = `<u>${i18n('delivery.RelayPoint.delivery.date', formatDate)}</u>`;
  const retailNetworkIdAttr = rp.retailNetworkID != null ? `data-retailNetworkId="${rp.retailNetworkID}"` : "";
  const context = cube.$id('relay-point').dataset.context;

  if (context === 'EXCHANGE') {
    deliveryLabel = `<u>${i18n('delivery.pickUpRelayPoint.reex.offered')}</u>`;
  }

  const template = `
      <input type="radio" id="${rp.locationCode}" class="checkout__shipping__input" name="delivery-type" value="${rp.locationCode}" data-type="relay-point" ${retailNetworkIdAttr} data-rpShippingOptionId="${shippingInfo.shippingOptionId}" data-index="${index}" ${cube.tnr.setDataTnr(['relay-point-radio'])}/>
      <label class="checkout__shipping__label" for="${rp.locationCode}">
        <span>
          <img 
            src="/vassets/images/checkout/carriers/${shippingInfo.shippingOptionId}.png"
            onerror="this.onerror=null;this.src='/vassets/images/checkout/carriers/default-pickup-relay.jpg'"
            class="logo" 
            alt="${rp.partnerName}"
          />
          <i>
            <i ${cube.tnr.setDataTnr(['relay-point-name'])} >${rp.name}</i>
            <p class="checkout__shipping__relay-info">
              ${shippingInfo.deliveryLabel ? deliveryLabel : deliveryLabelPhraseApp}

              <u>${addRelayPointPrice( shippingInfo.price.amount)}</u>
            </p>
            ${shippingInfo.description ? tooltipInfo : ''}
          </i>
        </span>
      </label>
      <div class="checkout__shipping__store">
        <div class="map-mobile"></div>
        <a href="#" class="mobile-btn-map"><span class="icon icon-pin"></span> ${i18n('delivery.pickUpRelayPoint.seeMap')}</a>
        <div class="checkout__shipping__store__address">
            <strong>${i18n('delivery.RelayPoint.address')}</strong>
            <span>${address1}${address3}${zipCode}${rp.address.city} ${rp.address.countrycode}</span>
        </div>
        <div class="checkout__shipping__store__timesheet">
            <strong>${i18n('delivery.RelayPoint.opening.hours')}</strong>
            ${getOpeningHours(rp.openingHours)}
        </div>
      </div>
  `;

  $('.checkout__shipping__stores-list').append(template);
  bindPannel();
};

let addRelayPointMarker = (rp) => {
  markers.push(
    new window.google.maps.Marker({
      map,
      title: rp.relayPoint.name,
      position: new window.google.maps.LatLng(
        rp.relayPoint.latitude,
        rp.relayPoint.longitude
      ),
      icon: {
        url: `/vassets/images/checkout/carriers/marker-${  rp.shippingOptionId  }.png`,
        size: new window.google.maps.Size(40, 44)
      }
    })
  );
};

function delegateMarkers() {
  const relayPointsInputs = cube.$$('.checkout__shipping__relay-point-generic .checkout__shipping__stores-list .checkout__shipping__input');

  relayPointsInputs.forEach(relay => {
    relay.addEventListener('change', setMarker);
  });
};

function setMarker(event) {
  window.google.maps.event.trigger(markers[event.target.dataset.index], 'click');
};

const addRelayPointPrice = (amount) => {
  const jsonPriceFormatterInfos = cube.$('.checkout__shipping__relay-point-generic').dataset.priceFormatterInfos;
  const priceFormatterInfos = JSON.parse(jsonPriceFormatterInfos);
  const htmlPrice = `<u class="amount-shipping" data-amount="${amount}" ${cube.tnr.setDataTnr('pick-up-in-relay-price')}>${cube.priceFormatter(amount, priceFormatterInfos)}</u>`;
  const context = cube.$id('relay-point').dataset.context;

  if(amount === 0) {
    if(context === 'EXCHANGE') {
      return '';
    // eslint-disable-next-line no-else-return
    } else {
      return i18n('delivery.RelayPoint.delivery.free', amount);
    }
  // eslint-disable-next-line no-else-return
  } else {
    return i18n('delivery.RelayPoint.delivery.pricing', htmlPrice);
  }
};

// Generate opening hours for each relaypoint
function getOpeningHours(openingHoursArray){

  let hours;
  let relayPointHours;

  return openingHoursArray.map((el) => {
    let displaySeparator = true;
    if (el.openingHourMorning === '' || el.openingHourEvening === '')
      displaySeparator = false;

    if(el.openingHour)
    {return `
      <div class="checkout__shipping__store__hours">
        <span class="day">${i18n(el.dayName)}</span>
        <span class="hours">
          <span class="morning">${el.openingHourMorning.replace(/[[\]']+/g,'')}</span>
          ${displaySeparator ? '<span>-</span>' : ''}
          <span class="evening">${el.openingHourEvening.replace(/[[\]']+/g,'')}</span>
        </span>
      </div>`;}

    return '';
  }).join('');
};

function selectRelayPoint(input){
  /* Position To scroll */
  $('.checkout__shipping__stores-list').animate({ scrollTop: input.nextSibling.offsetTop }, 200);

  if (!cube.ui.isMobile()) {
    window.google.maps.event.trigger(markers[input.dataset.index], 'click');
  }
};

// Open modal
// Get selected marker index and display it
function openRelayPointModal(event){
  containerMap.parentElement.classList.add('checkout__shipping__stores-map--open');
  cube.$('.checkout__shipping__stores-map--open').style.height = `${+ window.screen.height  }px`;

  // Get relaypoint informations
  const index = $('.checkout__shipping__input[data-type="relay-point"]:checked').attr('data-index');
  const relay = relayPoints[index];

  cube.$('.checkout__shipping__stores-map--open .title').innerHTML = relay.relayPoint.name;

  window.google.maps.event.trigger(map, 'resize');
  removePreviousRelayPoints();
  addRelayPointMarker(relay);
  map.setCenter(markers[0].getPosition());
  window.google.maps.event.trigger(map, 'resize');
};

function closeRelayPointModal(){
  cube.$('.checkout__shipping__stores-map').classList.remove('checkout__shipping__stores-map--open');
};

function setFilter(){
  if (!cube.ui.isMobile()) {
    searchNearestRelayPoints({
      latitude: map.getCenter().lat(),
      longitude: map.getCenter().lng(),
      filter: JSON.stringify({ shippingOptionIds: checkFilter() }),
      context: cube.$id('relay-point').dataset.context
    });
  } else {
    searchNearestRelayPoints({
      latitude: lastCoords.latitude,
      longitude: lastCoords.longitude,
      filter: JSON.stringify({ shippingOptionIds: checkFilter() }),
      context: cube.$id('relay-point').dataset.context
    });
  }
};

export { relayPointGeneric };



// WEBPACK FOOTER //
// ./src/modules-es5/checkout/shipping/relay-point-generic.js